export function formatReviewCountLabel(count?: number | null): string {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  if (n === 1) return "1 avaliação";
  return `${n} avaliações`;
}
